import {
	triggerSavedSearchPopoverCloseClickEvent,
	triggerSavedSearchPopoverCreateClickEvent,
	triggerSavedSearchPopoverEditClickEvent,
	triggerSavedSearchPopoverEditHoverEvent,
	triggerSavedSearchPopoverShowVehiclesHoverEvent,
} from 'Services/analytics/events';

import { POPOVER_GAEVENT_CONSTS } from './SavedSearchPopoverContent.consts';

const eventActionConfig = {
	[POPOVER_GAEVENT_CONSTS.closeButton]: triggerSavedSearchPopoverCloseClickEvent,
	[POPOVER_GAEVENT_CONSTS.hoverShowVehiclesButton]: triggerSavedSearchPopoverShowVehiclesHoverEvent,
	[POPOVER_GAEVENT_CONSTS.createSavedSearchButton]: triggerSavedSearchPopoverCreateClickEvent,
	[POPOVER_GAEVENT_CONSTS.clickEditButton]: triggerSavedSearchPopoverEditClickEvent,
	[POPOVER_GAEVENT_CONSTS.hoverEditButton]: triggerSavedSearchPopoverEditHoverEvent,
};

export const triggerSavedSearchPopoverGAEvent = (eventAction: string): void => {
	eventActionConfig[eventAction]?.();
};
